import ClipboardJS from 'clipboard';

const CopyToClipboard = {
  start() {
    const clipboardTarget = new ClipboardJS('[data-clipboard-target]');
    clipboardTarget.on('success', this.copySuccess);
    const clipboardText = new ClipboardJS('[data-clipboard-text]');
    clipboardText.on('success', this.copySuccess);
  },

  copySuccess(e) {
    const element = e.trigger;
    const tooltip = $(element).data('tooltip');
    $(element).attr('data-tooltip', 'Copied!');
    setTimeout(() => {
      $(element).attr('data-tooltip', tooltip);
    }, 3000);


    if (element.classList.contains('copy-to-clipboard')) {
      const originalHTML = element.innerHTML;
      const originalColor = element.style.color;
      element.textContent = 'Copied!';
      element.style.color = '#28a745';

      setTimeout(() => {
        element.innerHTML = originalHTML;
        element.style.color = originalColor;
      }, 2000);
    }
  }
};

export default CopyToClipboard;
